<template>
 <div>
 <!-- <div @click="onClick"> -->
      <div :class="selectState()" style="background: white; transition: all 0.3s;">
        <!-- <md-card style="background: white; transition: all 0.3s;" :class="selectState()"> -->
        <!-- <md-card md-with-hover style="background: white; transition: all 0.3s;" :class="selectState()"> -->
          <!-- <md-ripple> -->
        <spinner v-show="isLoadingImage" :line-size="4" :size="60" :speed="0.8" line-fg-color="#B23E53" style="position: absolute; left: 50%; margin-left: -27px; margin-top: 90px;"></spinner>
        <div style="width: auto; height: auto; position: relative; overflow: hidden;">
          <img class="figure-img img-fluid" alt="" :src="thumbnail_src"  onerror="this.src='static/img/m_e_others_500.png'" @load="isLoadingImage=false">
        </div>
        <div class="topleft">
          <b-input-group>
            <div v-if="publicflg">
              <b-badge class="badgetl" variant="danger">公開</b-badge>
            </div>
            <div v-else>
              <b-badge class="badgetl" variant="secondary">非公開</b-badge>
            </div>
            <h4>
              <div v-if="lockflg">
                <span class="badge badge-pill badge-warning" style="margin-left: 8px;">
                  <i class="fa fa-lock icons font-2xl d-block"></i>
                </span>
              </div>
              <div v-else>
              </div>
            </h4>
          </b-input-group>
        </div>
        <div class="topright">
          <!-- <input type="checkbox" style="transform: scale(2);" v-model="checkStatus" @change="onClick"> -->

          <label class="checkbox"><input type="checkbox" v-model="checkStatus" @change="onClick"></label>
          <!-- <label for="PlanData.planid" class="checkbox"></label>
          <label for="PlanData.planid" class="checkbox"></label> -->
           <!-- <input type="checkbox" name="piyo" value="西木野さん" checked id="PlanData.planid" v-model="checkStatus" @change="onClick">
           <label for="PlanData.planid" class="checkbox"></label> -->
        </div>
        <div class="card-body">
        <p class="h4"> {{ PlanData.name }}  </p>
        <div class="row">
          <div class="col-auto align-self-end">
             <small class="text-muted">{{ strday }}</small><br>
             <small class="text-muted">{{ strexpiretime }}</small>
          </div>
          <div class="col">
            <b-dropdown id="ddown-buttons" text="編集" variant="primary" class="float-right">
              <template slot="button-content">
                <i class="fa fa-cog"></i> 編集
              </template>
              <b-dropdown-item-button @click="dispQrCode()"><i class="fa fa-qrcode"></i>QRコード表示</b-dropdown-item-button>
              <b-dropdown-item-button :class="dropdownState()" v-if="publicflg" @click="switchPublicflg()"><i class="fa fa-eye-slash"></i>非公開</b-dropdown-item-button>
              <b-dropdown-item-button :class="dropdownState()" v-else @click="switchPublicflg()"><i class="fa fa-eye"></i>公開</b-dropdown-item-button>
              <b-dropdown-item-button :class="dropdownLockState()" v-if="lockflg" @click="switchProtectflg()"><i class="fa fa-unlock"></i>ロック解除</b-dropdown-item-button>
              <b-dropdown-item-button :class="dropdownLockState()" v-else @click="switchProtectflg()"><i class="fa fa-lock"></i>ロック（モデルハウス用）</b-dropdown-item-button>
              <b-dropdown-item-button :class="dropdownState()" @click="checkDelete(PlanData.name)"><i class="fa fa-eraser"></i>削除</b-dropdown-item-button>
              <b-dropdown-item-button @click="dispPopup()" v-if="gradeflg"><i class="fa fa-share-square-o"></i>LINE連携</b-dropdown-item-button>
            </b-dropdown>
            <!-- <b-button variant="lgiht" @click="dispQrCode()"  class="float-right" style="color: #333333;">
              <i class="fa fa-qrcode"></i> QRコード
            </b-button> -->
          </div>
        </div>
     </div>
     <!-- </md-ripple> -->
     <!-- </md-card> -->
      </div>
    <b-modal v-model="deletestartshow" centered title="A's 3D Player" ok-title='OK' cancel-title="キャンセル" body-text-variant="" @ok="deletePlandata()">
      {{ text_delete }}
    </b-modal>
    <b-modal v-model="qrcodeshow" centered :title="PlanData.name" size="sm" body-text-variant="">
      <img :src="image_src" class="card-img-top" alt="">
      <template slot="modal-footer">
        <div class="w-100">
          <b-button variant="primary" class="float-left" @click="downloadQrCode">QRコード保存</b-button>
          <b-button variant="secondary" class="float-right" @click="qrcodeshow=false">OK</b-button>
        </div>
      </template>
    </b-modal>
    <b-modal v-model="popupshow" centered title="3D Player LINE連携" ok-title="閉じる" ok-only>
      <b-row>
        <b-col sm="2">
          <label for="url-textarea">URL</label>
        </b-col>
        <b-col sm="10">
          <b-form-textarea id="url-textarea" class="bg-white" readonly :value="snsurl" rows="3" no-resize></b-form-textarea>
          <b-row class="pt-2">
            <b-col><b-button class="btn-sm" @click="copyToClipboard">URL コピー</b-button></b-col>
            <b-col class="text-right">
              <b-link v-bind:href="lineShareUrl" target="_blank">
                <b-button>LINE送信</b-button>
              </b-link>
            </b-col>
          </b-row>
        </b-col>
      </b-row>
    </b-modal>
    <b-modal v-model="errorshow" centered title="" ok-title='OK' body-text-variant="" ok-only>
      {{ text_error }}
    </b-modal>
    <!-- <md-dialog :md-active.sync="qrcodeshow">
      <img :src="image_src" class="card-img-top" alt="">
    </md-dialog> -->
    <loading v-show="isLoading" msg="更新中..."></loading>
 </div>
</template>

<script>
import Loading from '../../components/Loading'
import Store from '@/store'
import ApiAccess from '@/components/ApiAccess'
import Spinner from 'vue-simple-spinner'

export default {
  mixins: [ ApiAccess ],
  components: {
    Loading,
    Spinner
  },
  name: 'PlanCard',
  props: ['PlanData', 'CheckFlg', 'PublicFlg', 'ProtectFlg', 'SelectedFlg', 'GradeName'],
  computed: {
    gradeflg: function () {
      return this.GradeName !== 'ライト'
    },
    lineShareUrl: function () {
      var userAgent = navigator.userAgent.toLowerCase()
      if (userAgent.search(/iphone|ipad|ipod|mac|android/) > -1) {
        return encodeURI('https://line.me/R/msg/text/?' + this.snsmsg + '\r\n' + this.snsurl)
      } else {
        return encodeURI('https://social-plugins.line.me/lineit/share?url=' + this.snsurl + '&text=' + this.snsmsg)
      }
    }
  },
  data () {
    return {
      strday: '',
      strlock: '',
      deletestartshow: false,
      text_delete: '',
      isLoading: false,
      image_src: '',
      qrcodeshow: false,
      popupshow: false,
      thumbnail_src: 'static/img/baseimage.png',
      badgetype: '',
      publicflg: false,
      lockflg: false,
      errorshow: false,
      text_error: '',
      dropdown: false,
      isLoadingImage: false,
      checkStatus: false,
      strexpiretime: '',
      snsurl: '',
      snsmsg: 'お世話になっております。\r\n住宅の完成イメージを3Dでご覧いただけます。\r\n閲覧には、専用無料アプリが必要です。\r\n※パソコンからはご覧いただけません。'
    }
  },
  async created () {
    this.strday = '更新日：' + this.PlanData.updatetime
    this.checkStatus = this.PlanData.checkFlg
    this.text_delete = '選択したデータを削除すると復元できませんが、削除しますか？'
    this.updatePlanInfo()
    var strToken = Store.state.token

    this.isLoadingImage = true
    var imagesrc = await this.$_Api_GetThumbnail(strToken, this.PlanData.planid)
    this.thumbnail_src = imagesrc
    if (this.PlanData.expiretime) {
      this.strexpiretime = '期限日：' + this.PlanData.expiretime
    }
  },
  watch: {
    CheckFlg: function (val) {
      this.checkStatus = val
    },
    PublicFlg: function (val) {
      this.publicflg = val
    },
    ProtectFlg: function (val) {
      this.lockflg = val
    }
  },
  methods: {
    selectState () {
      // if (this.checkStatus) {
      //   return 'md-card-select card md-elevation-2'
      // } else {
      //   return 'md-card card md-elevation-1'
      // }
      if (this.checkStatus) {
        return 'cstm-select card'
      } else {
        return 'cstm-card card'
      }
    },
    dropdownState () {
      if (this.SelectedFlg) {
        return 'edit-dropdown-gray'
      } else {
        return 'edit-dropdown'
      }
    },
    dropdownLockState () {
      if (this.PlanData.disableprotectflg) {
        return 'edit-dropdown-gray'
      } else if (this.SelectedFlg) {
        return 'edit-dropdown-gray'
      } else {
        return 'edit-dropdown'
      }
    },
    handleOk () {
    },
    showModel () {
      this.$root.$emit('bv::show::modal', 'modal1')
    },
    onHidden (evt) {
      this.$refs.btnShow.$el.focus()
    },
    getRowCount (items) {
      return items.length
    },
    checkDelete (planName) {
      if (this.SelectedFlg) {
        this.text_error = '選択中は、上部にある「選択中の物件編集」から編集してください。'
        this.errorshow = true
      } else if (this.PlanData.publicflg) {
        this.text_error = '物件を削除する為には、非公開に設定してください。'
        this.errorshow = true
      } else if (this.PlanData.protectflg) {
        this.text_error = '物件を削除する為には、ロック解除してください。'
        this.errorshow = true
      } else {
        this.deletestartshow = true
      }
    },
    GetDayStr (plandatatime) {
      return ''
    },
    getColor () {
      return 'danger'
    },
    updatePlanInfo () {
      this.publicflg = this.PlanData.publicflg
      this.lockflg = this.PlanData.protectflg
    },
    async deletePlandata () {
      var strToken = Store.state.token
      this.isLoading = true
      await this.$_Api_DeletePlan(strToken, this.PlanData.planid)
      this.$emit('delete-event', this.PlanData.planid)
      this.isLoading = false
    },
    async checkPublic () {
      var userInfo = await this.$_Api_GetUserInfo(Store.state.token, Store.state.companyid)
      if (userInfo === undefined) {
        return false
      }
      if (userInfo.data.limitpublic <= userInfo.data.countpublic) {
        this.text_error = '同時公開可能数を超えるため公開できません。公開するには他の住宅3Dデータを非公開に設定するか、上位コースをご契約ください。'
        this.errorshow = true
        return false
      } else {
        return true
      }
    },
    async switchPublicflg () {
      if (this.SelectedFlg) {
        this.text_error = '選択中は、上部にある「選択中の物件編集」から編集してください。'
        this.errorshow = true
        return
      }
      var postData = {
        'publicflg': !this.PlanData.publicflg
      }
      if (postData.publicflg) {
        if (!await this.checkPublic()) {
          return
        }
      }
      await this.putPlanInfo(postData)
    },

    async switchProtectflg () {
      if (this.PlanData.disableprotectflg) {
        return
      }

      if (this.SelectedFlg) {
        this.text_error = '選択中は、上部にある「選択中の物件編集」から編集してください。'
        this.errorshow = true
        return
      }
      var postData = {
        'protectflg': !this.PlanData.protectflg
      }
      this.putPlanInfo(postData)
    },

    async dispQrCode () {
      this.isLoading = true
      this.image_src = await this.$_Api_GetQRImage(this.PlanData.planid)
      this.isLoading = false
      this.qrcodeshow = true
    },

    async downloadQrCode () {
      // モダンブラウザ向け (Chrome, Edgeなど) - 保存先指定ダイアログを表示
      if (window.showSaveFilePicker) {
        try {
          const handle = await window.showSaveFilePicker({
            suggestedName: this.PlanData.name + '_QRコード.png',
            types: [{
              description: 'PNG Image',
              accept: { 'image/png': ['.png'] }
            }]
          })
          const writable = await handle.createWritable()
          const response = await fetch(this.image_src)
          const blob = await response.blob()
          await writable.write(blob)
          await writable.close()
        } catch (err) {
          // ユーザーによるキャンセルは無視、それ以外のエラーはログ出力
          if (err.name !== 'AbortError') {
            console.error('File save failed:', err)
          }
        }
      } else {
        // 従来の方法 (Firefox, Safariなど)
        // ユーザーのブラウザ設定で「ダウンロード前にファイルの保存場所を確認する」がONであればダイアログが出る
        var link = document.createElement('a')
        link.href = this.image_src
        link.download = this.PlanData.name + '_QRコード.png'
        link.click()
      }
    },

    // qrコード表示用のポップアップ生成
    async dispPopup () {
      this.isLoading = true
      var postData = {
        'planid': this.PlanData.planid
      }
      var snsData = await this.$_Api_GetSnsUrl(postData)
      this.snsurl = snsData.url
      this.isLoading = false
      this.popupshow = true
    },

    async copyToClipboard () {
      if (navigator.clipboard !== undefined) {
        navigator.clipboard.writeText(this.snsurl)
      } else if (window.clipboardData) {
        // Internet Explorer対応
        window.clipboardData.setData('Text', this.snsurl)
      } else {
        var userAgent = navigator.userAgent.toLowerCase()
        // iOS対応
        if (userAgent.search(/iphone|ipad|ipod|mac/) > -1) {
          var textArea = document.getElementById('url-textarea')

          // コピー可能な仮想のTextAreaを生成
          textArea = document.createElement('textArea')
          textArea.readOnly = true
          textArea.contentEditable = true
          textArea.value = this.snsurl
          document.body.appendChild(textArea)

          var range = document.createRange()
          range.selectNodeContents(textArea)

          var selection = window.getSelection()
          selection.removeAllRanges()
          selection.addRange(range)
          textArea.setSelectionRange(0, 999999)

          // URLをクリップボードにコピーする
          document.execCommand('copy')
          document.body.removeChild(textArea)
        } else {}
      }
    },

    async putPlanInfo (postData) {
      var strToken = Store.state.token
      this.isLoading = true
      var newPlanData = await this.$_Api_SetPlanInfo(strToken, this.PlanData.planid, postData)
      if (newPlanData !== undefined) {
        this.PlanData.name = newPlanData.data.name
        this.PlanData.publicflg = newPlanData.data.publicflg
        this.PlanData.protectflg = newPlanData.data.protectflg
        this.updatePlanInfo()
      }
      this.$emit('update-event', '')
      this.isLoading = false
    },

    imgError (image) {
      image.onerror = ''
      image.src = 'static/img/avatars/AsSpotlight.png' // 置き換えたい画像のURL
      return true
    },
    onClick () {
      this.$emit('click-event', this.PlanData)
    }
  }
}
</script>

<style>
.topleft {
  position: absolute; top: 4px; left: 4px;
}
.badgetl {
  padding: 8px;
  padding-left: 18px;
  padding-right: 18px;
  font-size: 14px;
  font-weight: normal;
}
.topright {
  position: absolute; top: 4px; right: 4px;
}
.md-card {
  margin-bottom: 25px;
  transition: all 1.0s;
}
.md-card-select {
  margin-bottom: 21px;
  box-shadow: 0px 3px 15px rgba(178,62,83,0.2);
  border: solid 4px #B23E53;
  transition: border 0.5s ease-out;
  -o-transition: border 0.5s ease-out;
  -moz-transition: border 0.5s ease-out;
  -webkit-transition: border 0.5s ease-out;
  -ms-transition: border 0.5s ease-out;
}
.cstm-card {
  margin-bottom: 25px;
   transition: all 1.0s;
}
.cstm-select {
  margin-bottom: 21px;
  box-shadow: 0px 3px 15px rgba(178,62,83,0.2);
  border: solid 4px #B23E53;
  transition: border 0.5s ease-out;
  -o-transition: border 0.5s ease-out;
  -moz-transition: border 0.5s ease-out;
  -webkit-transition: border 0.5s ease-out;
  -ms-transition: border 0.5s ease-out;
}
.edit-dropdown {
  color:  #333333;
}
.edit-dropdown-gray {
  color:  #c2cfd6;
}
/** cstmCheckBox **/
label.checkbox, label.checkbox_text {
  position      : relative;
  cursor        : pointer;
  display       : inline-block;
  overflow      : hidden;
  box-sizing    : border-box;
}
label.checkbox {
  width      : 26px;
  height     : 26px;
  border     : 1px solid #c2cfd6;
  background :#f0f3f5;
}
label.checkbox_text {
  padding-left : calc(24px + 5px);
  line-height  : 24px;
}
/** before after **/
label.checkbox_text:before,
label.checkbox:after, label.checkbox_text:after{
  content  : '';
  position : absolute;
  box-sizing : border-box;
}
label.checkbox:after{
  top              : 0px;
  bottom           : 0px;
  left             : 0px;
  right            : 0px;
  margin           : auto;
}
label.checkbox:after, label.checkbox_text:after{
  transform         : rotate(45deg);
  -webkit-transform : rotate(45deg);
  -moz-transform    : rotate(45deg);
  border-right      : 6px solid #B23E53;
  border-bottom     : 6px solid #B23E53;
  top               : calc(50% - (((24px / 12 ) * 5) / 2));
  display           : block;
  margin-top        : calc(((24px / 12 ) * 5) * -1);
  width             : calc(((24px / 12 ) * 5));
  height            : 24px;
  z-index           : 1;
}

label.checkbox_text:before {
  width    : 24px;
  height   : 24px;
  left     : 0px;
  top      : 0;
  border   : 1px solid #B23E53;
  z-index  : 3;
  box-sizing: border-box;
}

label.checkbox_text:after {
  left : calc((24px / 2) - (((24px / 12 ) * 5) / 2));
}
/** input **/
label.checkbox input[type="checkbox"], label.checkbox_text input[type="checkbox"]{
  -moz-appearance: none;
  -webkit-appearance: none;
  position   : absolute;
  z-index    : 2;
  margin     : 0px;
  width      : 24px;
  height     : 24px;
  box-sizing    : border-box;
  outline       : none;
}
label.checkbox input[type="checkbox"], label.checkbox_text input[type="checkbox"]{
  left       : calc(24px * -1);
  padding    : 0;
}

label.checkbox input[type="checkbox"] {
  box-shadow : 24px 0px #FFF;
}
label.checkbox_text input[type="checkbox"] {
  display    : block;
  box-shadow : 24px 0px #FFF;
}
/** checked forcus */
label.checkbox_text input[type="checkbox"]:checked,
label.checkbox input[type="checkbox"]:checked{
  box-shadow : none;
}
label.checkbox_text input[type="checkbox"]:checked:focus,
label.checkbox input[type="checkbox"]:checked:focus{
  opacity: 0.1;
}

label.checkbox_text input[type="checkbox"]:checked:focus {
  box-shadow : 24px 0px #666;
}
label.checkbox_text input[type="checkbox"]:focus {
  box-shadow : 24px 0px #EEE;
}
label.checkbox input[type="checkbox"]:checked:focus {
  box-shadow : 24px 0px #666;
}
label.checkbox input[type="checkbox"]:focus {
  box-shadow : 24px 0px #EEE;
}
</style>



// WEBPACK FOOTER //
// src/views/home/PlanCard.vue